import { c as _c } from "react/compiler-runtime";
import { UseQueryResult } from "@tanstack/react-query";
import { fetcher } from "@website/fetcher/fetcher";
import { useFetcher } from "@website/fetcher/use-fetcher";
import { USER_TRACKING_EVENTS } from "@website/tracking/tracking.types";
import { addEventToTracking } from "@website/tracking/user";
import { AUTH_ENDPOINTS } from "./constants";
import { AuthResponse, B2BProfile, UserInfo, UserInfoUpdateBody } from "./types";
import { saveLogin, useJwtToken, useLoginStatus } from "./utils";
export const convert = (token: string) => fetcher<AuthResponse>({
  url: AUTH_ENDPOINTS.CONVERT,
  method: "POST",
  data: {
    snappToken: token
  }
}).then(({
  data
}) => {
  saveLogin(data);
  addEventToTracking(USER_TRACKING_EVENTS.JEK_LOGIN, {
    product: "core"
  });
});
export const useProfile = () => {
  const $ = _c(7);
  const {
    profileType
  } = useJwtToken();
  const {
    isLoggedIn
  } = useLoginStatus();
  const url = profileType === "B2B" ? AUTH_ENDPOINTS.B2B_PROFILE : AUTH_ENDPOINTS.ME;
  let t0;
  let t1;
  if ($[0] !== url) {
    t0 = [url];
    t1 = () => new Promise(resolve => {
      fetcher({
        url
      }).then(t2 => {
        const {
          data
        } = t2;
        return resolve(data);
      }).catch(async () => {
        resolve(undefined);
      });
    });
    $[0] = url;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  let t2;
  if ($[3] !== isLoggedIn || $[4] !== t0 || $[5] !== t1) {
    t2 = {
      enabled: isLoggedIn,
      queryKey: t0,
      queryFn: t1
    };
    $[3] = isLoggedIn;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return useFetcher(t2) as UseQueryResult<ProfileType>;
};
export const useUserInfo = () => {
  const $ = _c(7);
  const {
    isLoggedIn
  } = useLoginStatus();
  const {
    profileType
  } = useJwtToken();
  const url = profileType === "B2B" ? AUTH_ENDPOINTS.B2B_PROFILE : AUTH_ENDPOINTS.ME;
  let t0;
  let t1;
  if ($[0] !== url) {
    t0 = [url];
    t1 = () => fetcher({
      url
    }).then(_temp);
    $[0] = url;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  let t2;
  if ($[3] !== isLoggedIn || $[4] !== t0 || $[5] !== t1) {
    t2 = {
      enabled: isLoggedIn,
      queryKey: t0,
      queryFn: t1
    };
    $[3] = isLoggedIn;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return useFetcher(t2);
};
export const useB2BProfile = () => {
  const $ = _c(3);
  const {
    isLoggedIn
  } = useLoginStatus();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [AUTH_ENDPOINTS.B2B_PROFILE];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== isLoggedIn) {
    t1 = {
      enabled: isLoggedIn,
      queryKey: t0,
      queryFn: _temp3
    };
    $[1] = isLoggedIn;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return useFetcher(t1);
};
export const updateUserInfo = (url: string, data: UserInfoUpdateBody) => fetcher<UserInfo>({
  url,
  method: "PATCH",
  data
}).then(({
  data
}) => data);
function _temp(t0) {
  const {
    data
  } = t0;
  return data;
}
function _temp2(t0) {
  const {
    data
  } = t0;
  return data;
}
function _temp3() {
  return fetcher({
    url: AUTH_ENDPOINTS.B2B_PROFILE
  }).then(_temp2);
}